import { dictionaryApi } from './dictionaryClient';

export type AmarkoshWordSynonymScalars = {
  amarkoshWordId: number;
  subantaId: number;
};

export type AmarkoshWordSynonym = AmarkoshWordSynonymScalars & {
  id: number;
  createdAt?: string;
  updatedAt?: string;
  created_at?: string;
  updated_at?: string;
};

export type CreateAmarkoshWordSynonymBody = AmarkoshWordSynonymScalars;

function normalizeList(data: unknown): AmarkoshWordSynonym[] {
  if (Array.isArray(data)) return data as AmarkoshWordSynonym[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: AmarkoshWordSynonym[] }).data;
  }
  return [];
}

export async function listAmarkoshWordSynonyms(): Promise<AmarkoshWordSynonym[]> {
  const res = await dictionaryApi.get<unknown>('/amarkosh-word-synonym');
  return normalizeList(res.data);
}

export async function getAmarkoshWordSynonym(id: number): Promise<AmarkoshWordSynonym> {
  const res = await dictionaryApi.get<AmarkoshWordSynonym>(`/amarkosh-word-synonym/${id}`);
  return res.data;
}

export async function createAmarkoshWordSynonym(
  body: CreateAmarkoshWordSynonymBody
): Promise<AmarkoshWordSynonym> {
  const res = await dictionaryApi.post<AmarkoshWordSynonym>('/amarkosh-word-synonym', body);
  return res.data;
}

export async function updateAmarkoshWordSynonym(
  id: number,
  body: Partial<AmarkoshWordSynonymScalars>
): Promise<AmarkoshWordSynonym> {
  const res = await dictionaryApi.patch<AmarkoshWordSynonym>(
    `/amarkosh-word-synonym/${id}`,
    body
  );
  return res.data;
}

export async function deleteAmarkoshWordSynonym(id: number): Promise<void> {
  await dictionaryApi.delete(`/amarkosh-word-synonym/${id}`);
}
